import { useContext, useEffect, useState } from "react";
import { InvoiceListInfo } from "../../../../generated/data-contracts";
import { AvisContext } from "../../../shared/context/AvisContext";

import moment from "moment";
import { api, IAxiosError, LicenseesUtils } from "../../../../utils";
import { AvisSimpleTable } from "../../../shared/components/table";
import { columnConfigInvoices } from "../columnConfigInvoices";

interface IInvoicesGridProps {
  setError: React.Dispatch<React.SetStateAction<IAxiosError | undefined>>;
}
export function InvoicesGrid(props: Readonly<IInvoicesGridProps>) {
  const { setError } = props;
  const { res } = useContext(AvisContext);
  const [loadingInvoices, setLoadingInvoices] = useState<boolean>(true);
  const [invoices, setInvoices] = useState<InvoiceListInfo[]>();

  const columnMetadata = columnConfigInvoices(false, res);
  const licenseId = LicenseesUtils.getUrlParams().licenseId;

  useEffect(() => {
    setLoadingInvoices(true);

    const endpoint = licenseId
      ? api.licenseesGetInvoicesWithPaymentOwedForLicense(licenseId)
      : api.licenseesGetInvoicesWithPaymentOwed();

    endpoint
      .then((res) => setInvoices(res.data))
      .catch(setError)
      .finally(() => setLoadingInvoices(false));
  }, [licenseId, setError]);

  return (
    <AvisSimpleTable<InvoiceListInfo>
      columnMetadata={columnMetadata}
      data={invoices}
      loading={loadingInvoices}
      conditionalFormatting={[
        {
          field: "dueDate",
          trueClass: "avis-highlight-red",
          falseClass: "",
          condition: (val) => {
            return moment(val).startOf("day") < moment().startOf("day");
          },
        },
      ]}
    />
  );
}
